<div class="task-list-container" style="width: 100%;">
    <div class="task-list-header">
        <div class="header-cell">Task</div>
        <div class="header-cell">Due Date</div>
        <div class="header-cell">Owner</div>
        <div class="header-cell">Outcome </div>
        <div class="header-cell">Notes </div>

    </div>

    <div class="task-list-body" *ngIf="activityList.length > 0; else emptyStateTask">

        <div class="scroll-box" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200"
            (scrolled)="onScroll()">
            <div *ngFor="let task of activityList" class="task-row">
                <div class="task-cell task-subject" data-label="Task">
                    <p class="note-text">{{ task.subject==null?task.activityType:task.subject }}</p>

                </div>

                <div class="task-cell due-date" data-label="Due Date">

                    <ng-container [class.overdue]="isOverdue(task)" *ngIf="isOverdue(task)&&task.status==0">


                        Overdue since {{ task.dueDateTime | date:'MMM dd, yyyy | HH:mm'
                        }}
                    </ng-container>

                    <ng-container *ngIf="task.status==1">

                        {{ task.dueDateTime | date:'MMM dd, yyyy | HH:mm' }}
                    </ng-container>

                    <ng-container [class.overdue]="isOverdue(task)" *ngIf="!isOverdue(task)&&task.status==0">

                        {{ task.dueDateTime | date:'MMM dd, yyyy | HH:mm'
                        }}
                    </ng-container>




                </div>
                <div class="task-cell" data-label="Owner">{{ task.owner ==null?'ADMIN': task.owner }}</div>
                <div class="task-cell" data-label="Outcome">{{ task.phoneCallOutcome || '--' }}</div>
                <!-- <div class="task-cell" data-label="Notes">{{ task.notes || '--' }}</div> -->

                <div class="task-cell notes-cell" data-label="Notes">
                    <span [class.collapsed]="!task.expanded" style="width: 10ch;">
                        {{ task.notes || '--' }}
                    </span>

                    <mat-icon *ngIf="task.notes?.length > 0" class="toggle-icon" (click)="toggleNotes(task, $event)"
                        [class.rotate]="task.expanded">
                        keyboard_arrow_down
                    </mat-icon>
                </div>

                <div class="task-cell actions">

                    <button [attr.guide]="'task-new-btn-1' + '__' + sanitizeUrl(url)"
                        (click)="addLeadActivity('Edit', 0, task, 3)"
                        *ngIf="task.status==0 && !isSiteVisit(task)" class="action-btn">
                        ✓ Mark complete
                    </button>

                    <button [attr.guide]="'task-new-btn-sitevisit' + '__' + sanitizeUrl(url)"
                        (click)="openSiteVisitPopup(task)" *ngIf="isSiteVisit(task)"
                        class="action-btn">
                        Site Visit
                    </button>


                    <button [attr.guide]="'task-new-btn-2' + '__' + sanitizeUrl(url)" type="button" mat-icon-button
                        [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button [attr.guide]="'task-new-btn-3' + '__' + sanitizeUrl(url)"
                            (click)="isSiteVisit(task) ? openSiteVisitPopup(task) : addLeadActivity('Edit', 0, task,3)"
                            mat-menu-item>
                            <mat-icon>{{ isSiteVisit(task) ? 'event' : 'add_notes' }}</mat-icon>
                            <span>{{ isSiteVisit(task) ? 'Site Visit' : 'Add OutCome' }}</span>
                        </button>

                        <button [attr.guide]="'task-new-btn-4' + '__' + sanitizeUrl(url)"
                            (click)="addLeadActivity('Edit', 0, task,taskType)" *ngIf="!isSiteVisit(task)"
                            mat-menu-item>
                            <mat-icon>edit</mat-icon>
                            <span>edit</span>
                        </button>
                        <button [attr.guide]="'task-new-btn-5' + '__' + sanitizeUrl(url)"
                            (click)="deleteLeadDialog(task.id)" mat-menu-item
                            *ngIf="!isSiteVisit(task)">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>

                </div>
            </div>
        </div>



    </div>
    <ng-template #emptyStateTask>
        <div class="empty-notes">
            <span class="material-icons-outlined empty-icon">description</span>
            <p>Tasks help you keep track of things you need to do.</p>
        </div>
    </ng-template>
</div>

<ng-template #delete>

    <div class="index-head">
        <span>Delete</span>
    </div>
    <div class="padding-index">
        <span>Do you want to Delete a Lead Activity</span>
    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'task-new-btn-6' + '__' + sanitizeUrl(url)" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'task-new-btn-7' + '__' + sanitizeUrl(url)" [disabled]="textAccount !='OK'"
            (click)="submit()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='OK' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</ng-template>